import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE } from '@/utils/constants';
import { Component, Vue } from 'vue-property-decorator';
import Preference from './preference/preference';

@Component({
    components: {
        preference: Preference,
    },
})
export default class Profile extends Vue {

    private userType: string = '';

    private userTypeList: any = USER_TYPE;

    private get session() {
        return sessionService.getSession();
    }

    private ProfileComponents: any = {
        preference: 'preference',
    };

    private profileMenu: Array<{ active: string, icon: string, label: string, isFileUpload?: boolean }> = [
        {
            active: 'preference',
            icon: 'dashboard',
            label: 'Preference',
        },
    ];

    private activeComponent = this.profileMenu[0].active;

    // ----------------------------------------------------------------
    // Hooks

    private created() {
        this.userType = this.$access.getUserType();
    }

    private onSelectComponent(selected: any) {
        this.activeComponent = selected.active;
    }
}

